import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, AfterContentChecked } from '@angular/core';
import { Subscription } from 'rxjs';
import { DealerPage } from '../../shared/shared.interface';
import { SharedService } from '../../shared/shared.service';
import { AddressState, KngMydealer, KngMydealerState } from './definitions';
import { KngMydealerService } from './kng-mydealer.service';
import { LibIcons, NullCheck } from '../../constants/global.constant';
import { KngLoaderState } from '../loader';


@Component({
	selector: 'kng-mydealer',
	templateUrl: './template/kng-mydealer.component.html',
	styleUrls: ['./template/kng-mydealer.component.scss']
})
export class KngMydealerComponent implements KngMydealer, OnInit, OnDestroy, AfterContentChecked
{

	private subscriptions: Subscription = new Subscription();
	parentPage!: typeof DealerPage;
	addressView: boolean = false;
	loaderState: KngLoaderState = { imagePath: LibIcons.widgetLoader };
    
    @Input() set state(value: KngMydealerState)
	{
		this.service.updateState(value);
	}
    get state(): KngMydealerState
    {
    	return this.service.state;
    }

    @Output() stateChanged: EventEmitter<KngMydealerState> = new EventEmitter<KngMydealerState>();
    @Output() clicked: EventEmitter<KngMydealerState> =
  	new EventEmitter<KngMydealerState>();
    @Output() contactClickOn: EventEmitter<'email' | 'phone-number'> = new EventEmitter<'email' | 'phone-number'>();

    constructor(
        private service: KngMydealerService, private sharedservice: SharedService
    )
    { }

    ngOnInit(): void
    {
    	this.initSubscriptions();
    	this.parentPage = DealerPage;
    }
    ngOnDestroy(): void
    {
    	this.destroySubscriptions();
    }

    ngAfterContentChecked(): void
    {
    	const addressState = this.state.myDealer.address.value;
    	if(addressState.addressLine1 === NullCheck.nullValue && addressState.city === NullCheck.nullValue && addressState.state === NullCheck.nullValue && addressState.zipCode === NullCheck.nullValue)
    	{
    		this.addressView = false;
    	}
	    else
    	{
    		this.addressView = true;
    	}
    }

    private initSubscriptions(): void
    {
    	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
    		(next: KngMydealerState) => this.stateChanged.emit(next)
    	);
    	this.subscriptions.add(stateChangeSubs);
    }
    private destroySubscriptions(): void
    {
    	this.subscriptions.unsubscribe();
    }

    public formatAddress(address:AddressState)
    {
    	return this.sharedservice.formatAddress(address.value, false);

    }
    public handleClick()
    {
    	this.clicked.emit(this.state);
    }
}
